import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "pageParametersForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "Name", required: false },
                model: {
                  value: _vm.pageParameters.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageParameters, "name", $$v)
                  },
                  expression: "pageParameters.name",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Page Name", required: false },
                model: {
                  value: _vm.pageParameters.page_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageParameters, "page_name", $$v)
                  },
                  expression: "pageParameters.page_name",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Vuex Name", required: false },
                model: {
                  value: _vm.pageParameters.vuex_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageParameters, "vuex_name", $$v)
                  },
                  expression: "pageParameters.vuex_name",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Owner Only", required: false },
                model: {
                  value: _vm.pageParameters.owner_only,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageParameters, "owner_only", $$v)
                  },
                  expression: "pageParameters.owner_only",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Created By", required: false },
                model: {
                  value: _vm.pageParameters.created_by,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageParameters, "created_by", $$v)
                  },
                  expression: "pageParameters.created_by",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Created on", required: true },
                model: {
                  value: _vm.pageParameters.create_time,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageParameters, "create_time", $$v)
                  },
                  expression: "pageParameters.create_time",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }